export class PipelineObjectConfigTrackers {
  static readonly PIPELINE_TRACKER_PIPELINE_OBJECT_CONFIG_CONTINUE_CLICK =
    '[Pipelines] pipeline object config continue click';

  static readonly PIPELINE_TRACKER_PIPELINE_OBJECT_CONFIG_SEARCH =
    '[Pipelines] pipeline object config search';

  static readonly PIPELINE_TRACKER_PIPELINE_OBJECT_FIELDS_CONFIG_SELECTION_MODE_CONFIG_MODAL_TOGGLE =
    '[Pipelines] pipeline object fields config selection mode config modal toggle';

  static readonly PIPELINE_TRACKER_PIPELINE_OBJECT_FIELDS_APPLY_CHANGES_CLICK =
    '[Pipelines] pipeline object config fields apply changes click';

  static readonly PIPELINE_TRACKER_PIPELINE_OBJECT_FIELDS_CLOSE_CLICK =
    '[Pipelines] pipeline object config fields close click';

  static readonly PIPELINE_TRACKER_PIPELINE_OBJECT_CONFIG_FIELDS_SEARCH =
    '[Pipelines] pipeline object config fields search';

  static readonly PIPELINE_TRACKER_PIPELINE_OBJECT_CONFIG_FIELDS_ALL_SELECT_CLICK =
    '[Pipelines] pipeline object config fields all select click';
}
